import * as THREE from 'three';

let materials = [];

export const getInkMat = name =>
  new THREE.MeshBasicMaterial({
    color: '#000000',
    side: THREE.FrontSide,
    name
  })

export const getBgMat = () =>
  new THREE.MeshBasicMaterial({
    color: '#1e2426',
    map: null
  })

export const getRenderTextureMat = (name, render) => 
  new THREE.MeshBasicMaterial({
    color: '#ffffff',
    map: render.texture,
    name
  })

export const getMaterialsName = mesh => mesh.material.map(mat => mat.name);
export const registerMaterial = mat => materials[mat.name] = mat;

export const listMeshMaterials = function (mesh) {
  let listMat = []
  if (mesh.material) {
    listMat = listMat.concat(mesh.material)
  } else if (mesh.children) {
    mesh.children.map(child => listMat = listMat.concat(listMeshMaterials(child)))
  }
  return listMat;
}

export const replaceMeshMaterials = function (mesh) {
  if (!mesh.material) return
  if (Array.isArray(mesh.material))
    mesh.material.map((mat, id, list) => {
      list[id] = materials[mat.name] || mat
      return list[id]
    })
  else mesh.material = materials[mesh.material.name] || mesh.material
}

export const overrideMat = function (mat, name = null) {
  if (name) {
    Object.assign(materials[name], mat)
  } else {
    Object.keys(materials).map(name => {
      return Object.assign(materials[name], mat)
    })
  }
}

export const createMatNormal = name => new THREE.MeshNormalMaterial({name})
export const createShaderMat = (params, raw=true) => raw ? new THREE.RawShaderMaterial(params) : new THREE.ShaderMaterial(params)
export const createTexture = () => new THREE.Texture()

export const createPageMaterial = (name, texture) => {
  const vertexShader = `
    varying vec3 vPos;
    varying vec2 vUv;

    uniform float openRatio;
    uniform float min;
    uniform float max;

    float pageRatio(float posx, float min, float max) {
      return (posx - min) / (max - min);
    }
    
    void main() {
      vPos = position;
      vUv = uv;
      vec3 newPos = position;
      float middleRatio = (openRatio - 0.5) * 2.0;
      float ratioPage = pageRatio(position.x, min, max);
      newPos.z = -( (ratioPage * ratioPage) * (-max + min) ) * ( 1.0 - abs(middleRatio) );
      // newPos.z = -( sin(sqrt(ratioPage)) * (-max + min) ) * ( 1.0 - abs(middleRatio) );
      newPos.x = min + ( ratioPage * (-max + min)) * middleRatio;
      gl_Position = projectionMatrix * modelViewMatrix * vec4( newPos, 1.0 );
    }`

  const fragmentShader = `
    varying vec3 vPos;
    varying vec2 vUv;
  
    uniform float openRatio;
    uniform float opacity;
    uniform float min;
    uniform float max;
    uniform sampler2D map;
  
    float pageRatio(float posx, float min, float max) {
      return (posx - min) / (max - min);
    }
  
    void main() {
      float ratio = pageRatio(vPos.x, min, max);
      //gl_FragColor = vec4(openRatio, 0.5, 0.5 ,1.0);
      //gl_FragColor = vec4(ratio, 0.5, 0.5 ,1.0);
      // gl_FragColor = texture2D(map, vUv);
      if (gl_FrontFacing) {
        gl_FragColor = texture2D(map, vUv) * vec4(1.0, 1.0, 1.0, opacity);
      } else {
        gl_FragColor = vec4(0.0, 0.0, 0.0 ,1.0);
      }
    }`

  const map = { value: texture }
  const openRatio = { value: 0 }
  const opacity = { value: 1.0 }
  const uniforms = { map, openRatio, opacity, min: { value: -5.0 }, max: { value: 5.0 } }
  return createShaderMat({
    vertexShader,
    fragmentShader,
    uniforms,
    name,
    side: THREE.DoubleSide,
    transparent: true
  }, false)
}


// WEBPACK FOOTER //
// ./src/scripts/helpers/MaterialHelper.js